import React from 'react';
import { FaInstagram, FaLinkedin, FaYoutube, FaTwitter, FaBlogger, FaTiktok } from 'react-icons/fa';
import { TiSocialFacebookCircular } from 'react-icons/ti';

const SocialNetworks = ({ socialNetworks, className = '' }) => {
  if (!socialNetworks || !socialNetworks.length) {
    return null;
  }

  const socialIcons = {
    Instagram: <FaInstagram style={{ fontSize: '20px' }} />,
    Facebook: <TiSocialFacebookCircular style={{ fontSize: '20px' }} />,
    Linkedin: <FaLinkedin style={{ fontSize: '20px' }} />,
    YouTube: <FaYoutube style={{ fontSize: '20px' }} />,
    Twitter: <FaTwitter style={{ fontSize: '20px' }} />,
    Blog: <FaBlogger style={{ fontSize: '20px' }} />,
    TikTok: <FaTiktok style={{ fontSize: '20px' }} />,
  };

  const validSocialNetworks = socialNetworks.filter((socialNetwork) => {
    // Verificar si la URL está en tipoEnlace.url o en valor
    const url = socialNetwork.tipoEnlace?.url || socialNetwork.valor;
    const hasValidUrl = url && url.trim() !== '';
    const hasIcon = socialIcons[socialNetwork.tipoEnlace?.descripcion];

    // NOTA: No validamos el campo `enabled` porque en la DB todas las redes sociales
    // llegan con enabled=false. Las redes sociales se muestran si tienen URL válida
    // y icono disponible, independientemente del valor de `enabled`.
    // Si en el futuro se necesita controlar la visibilidad específica,
    // se puede descomentar: && socialNetwork.enabled

    return hasValidUrl && hasIcon;
  });

  if (!validSocialNetworks.length) {
    return null;
  }

  return (
    <div className={`flex space-x-4 ${className}`}>
      {validSocialNetworks.map((socialNetwork, index) => {
        const iconComponent = socialIcons[socialNetwork.tipoEnlace.descripcion];
        const url = socialNetwork.tipoEnlace?.url || socialNetwork.valor;

        return (
          <div
            key={`${socialNetwork.tipoEnlace.descripcion}-${index}`}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <a
              href={url}
              rel='noopener noreferrer'
              style={{ alignItems: 'center' }}
              target='_blank'
            >
              {iconComponent}
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default SocialNetworks;
